import React, { useState, useEffect } from 'react';
import './FeedbackPopup.css';
import { getuserdata } from '../../../services/apiService';
import { oneKlicks } from '../../../SDK/oneclick';
import { toast } from 'react-toastify';


const FeedbackPopup = ({ isOpen, onClose, doctorId }) => {
    
    const [userDetails, setUserDetails] = useState({});
    const [feedback, setFeedback] = useState({
        rating: 5,
        comment: '',
        name: userDetails?.name || '',
        email: userDetails?.email || '',
        phone: userDetails?.phone || ''
    });
    const [errors, setErrors] = useState({});

    useEffect(() => {
        const fetchUserDetails = async () => {
            const responce = await getuserdata('full')
            setUserDetails(responce);
        };
        fetchUserDetails();
    }, [doctorId]);

    const handleSubmit = async (e) => {
        console.log('handleSubmit data :',e);
        e.preventDefault();
        const validationErrors = validate();
        console.log('validationErrors data :',validationErrors);
        if (Object.keys(validationErrors).length > 0) {
            toast.error(validationErrors.email || validationErrors.phone || validationErrors.name || validationErrors.comment || validationErrors.rating);
            setErrors(validationErrors);
            return;
        }
        setErrors({});
        // TODO: Add your feedback submission logic here
        console.log('Submitting feedback:', feedback);
        const tableSchema = '';
        const tableName = 'feedbacks';
        const data = {
            doctor_id: doctorId,
            user_id: userDetails?.id || '0',
            rating: feedback.rating,
            comment: feedback.comment,
            name: feedback.name,
            email: feedback.email,
            phone: feedback.phone
        };
        const conditions = {};

        const response = await oneKlicks.create(tableSchema, tableName, data, conditions);
        if(response){
            toast.success('Feedback submitted successfully');
            onClose();
        }else{
            toast.error('Failed to submit feedback');
        }
    };

    const validate = () => {
        const newErrors = {};
        if (!feedback.rating) newErrors.rating = "Rating is required";
        if (!feedback.comment.trim()) newErrors.comment = "Feedback is required";
        if (!feedback.name.trim()) newErrors.name = "Name is required";
        if (!feedback.phone.trim()) newErrors.phone = "Phone number is required";
        if (!feedback.email.trim()) newErrors.email = "Email is required";
        // Simple email regex
        // Improved email validation regex (no double escaping, more robust)
        if (feedback.email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(feedback.email)) {
            newErrors.email = "Invalid email address";
        }
        return newErrors;
    };

    if (!isOpen) return null;

    return (
        <div className="feedback-popup-overlay" onClick={onClose}>
            <div className="feedback-popup" onClick={e => e.stopPropagation()}>
                <button onClick={onClose} className="close-btn">×</button>
                <h2>Add Your Feedback</h2>
                <form onSubmit={handleSubmit}>
                    <div className="form-group">
                        <label>Rating:</label>
                        <div className="rating-starsnew">
                            {[1, 2, 3, 4, 5].map((star) => (
                                <span
                                    key={star}
                                    className={`star ${star <= feedback.rating ? 'active' : ''}`}
                                    onClick={() => setFeedback({ ...feedback, rating: star })}
                                >
                                    ★
                                </span>
                            ))}
                        </div>
                        {errors.rating && <div className="error">{errors.rating}</div>}
                    </div>

                    <div className="form-group">
                        <label htmlFor="comment">Your Feedback:</label>
                        <textarea
                            id="comment"
                            value={feedback.comment}
                            onChange={(e) => setFeedback({ ...feedback, comment: e.target.value })}
                            placeholder="Share your experience..."
                            required
                        />
                    </div>

                    <div className="form-group">
                        <label htmlFor="name">Your Name:</label>
                        <input
                            type="text"
                            id="name"
                            value={feedback.name}
                            onChange={(e) => setFeedback({ ...feedback, name: e.target.value })}
                            placeholder="Enter your name"
                            required
                        />
                    </div>
                    <div className="form-group">
                        <label htmlFor="phone">Your Phone Number:</label>
                        <input
                            type="text"
                            id="phone"
                            value={feedback.phone}
                            onChange={(e) => setFeedback({ ...feedback, phone: e.target.value })}
                            placeholder="Enter your phone number"
                            required
                        />
                    </div>

                    <div className="form-group">
                        <label htmlFor="email">Your Email:</label>
                        <input
                            type="email"
                            id="email"
                            value={feedback.email}
                            onChange={(e) => setFeedback({ ...feedback, email: e.target.value })}
                            placeholder="Enter your email"
                            required
                        />
                    </div>

                    <div className="form-actions">
                        <button type="button" className="cancel-btn" onClick={onClose}>
                            Cancel
                        </button>
                        <button type="submit" className="submit-btn" style={{marginTop: '0px'}}>
                            Submit Feedback
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default FeedbackPopup; 
